
<template>
    <v-container fluid pa-0 grid-list-sm>
        <progress-overlay :Loading="Loading"></progress-overlay>
        <div class="filterContainerHeader">
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" small icon @click="expandAll" v-show="checkIfPanelCollapsed()"><v-icon>add</v-icon></v-btn>
                </template>
                <span>Expand all filters.</span>
            </v-tooltip>
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" small icon @click="collapseAll" v-show="checkIfPanelExpanded()"><v-icon>remove</v-icon></v-btn>
                </template>
                <span>Collapse all filters.</span>
            </v-tooltip>
            <v-btn small color="black" @click="applyFilters" :dark="cohortFiltersApplied" :disabled="!cohortFiltersApplied">
                Apply Selections
            </v-btn>
        </div>
        <v-divider></v-divider>
        <VuePerfectScrollbar style="height:80vh">
            <v-layout wrap class="ma-0">
                <v-flex xs12 style="width:100%" class="cohortSegmentationFilterParent">
                    <CohortFilterList :Categories="filterCategories">
                    </CohortFilterList>
                </v-flex>
                <v-flex xs12>
                    <v-card flat>
                        <v-flex xs12 d-flex>
                            <span style="font-size:15px"><strong>Cohorts</strong></span>
                            <v-spacer></v-spacer>
                            <v-btn small dark @click="addNewCohort">Add New<v-icon right>add</v-icon></v-btn>
                            <CohortUpdate :Dialog="dialog"
                                          :CategoriesSegment="CategoriesSegment"
                                          :NewCohort="true"
                                          :CohortName="getCohortName()"
                                          v-on:cancelDialog="cancelDialog"></CohortUpdate>
                        </v-flex>
                        <v-flex xs12>
                            <p style="font-size:11px">
                                You may analyze up to 3 cohorts at a time. Please turn on the number of cohorts you would like to compare, then select your desired segments.
                            </p>
                        </v-flex>
                    </v-card>
                </v-flex>
                <v-flex xs12>
                    <CohortList></CohortList>
                </v-flex>
            </v-layout>
        </VuePerfectScrollbar>
    </v-container>
</template>
<script>
    import { mapState } from 'vuex';
    import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    import CohortFilterList from './CohortFilterList'
    import CohortList from './CohortList'
    import CohortUpdate from './CohortUpdate'
    import ProgressOverlay from '../_partial/ProgressOverlay'
    export default {
        components: {
            VuePerfectScrollbar,
            CohortFilterList,
            CohortList,
            CohortUpdate,
            ProgressOverlay
        },
        data() {
            return {
                Loading: false,
                dialog: false,
                //panel: [],
                //panelSegments: [],
                filtersUpdated: false,
            }
        },
        created() {
            //this.$store.dispatch('CategoriesStore/getAllCategories', 'cohort')
            this.$store.dispatch('UserSettingStore/getUserSettingData')
        },
        computed: {
            ...mapState({
                modelCohortListFilters: state => state.CategoriesStore.modelCohortListFilters,
                filterCategories: state => state.CategoriesStore.cohortMeasurefilterCategories,
                CategoriesSegment: state => state.CategoriesStore.cohortSegmentfilterCategories,
                userSettingData: state => state.UserSettingStore.userSettingData,
                modelCohortFilters: state => state.CategoriesStore.modelCohortFilters,
                cohortFiltersApplied: state => state.CategoriesStore.cohortFiltersApplied,
                cohortFilterRadios: state => state.CategoriesStore.cohortFilterRadios,
            }),
            panel: {
                get() {
                    return this.$store.state.CategoriesStore.cohortPanel;
                },
                set(newVal) {
                    this.$store.state.CategoriesStore.cohortPanel = newVal;
                }
            }
        },
        watch: {
            //modelCohortListFilters: function () {
            //    this.filtersUpdated = !this.filtersUpdated;
            //    //if (this.modelCohort.length > 0) {
            //    //    this.filtersUpdated = true;
            //    //}
            //    //else {
            //    //    this.filtersUpdated = false;
            //    //}
            //},
           // cohortFiltersApplied: function () {
             //   this.filtersUpdated = !this.filtersUpdated;
           // },
        },
        methods: {
            applyFilters() {
                /*var selectedCategories = [];
                for (var i = 0; i < this.modelCohortFilters.length; i++) {
                    var keyvalues = this.modelCohortFilters[i].keyValues;
                    var catName = this.modelCohortFilters[i].categoryName;
                    var selCategory = {
                        categoryName: catName,
                        keyValues: []
                    };
                    for (var j = 0; j < keyvalues.length; j++) {
                        var keyval = this.modelCohortFilters[i].keyValues[j];
                        if (keyval.isSelected) {
                            var newKeyVal = {
                                itemName: keyval.itemName,
                                itemValue: keyval.itemValue
                            }
                            selCategory.keyValues.push(newKeyVal);
                        }
                    }
                    if (selCategory.keyValues.length > 0) {
                        selectedCategories.push(selCategory);
                    }
                }*/

                let selectedCategories = [];

                this.filterCategories.map((cat) => {
                    let selCategory = {
                        categoryName: cat.categoryName,
                        keyValues: []
                    };
                    let keyval = cat.keyValues.filter((data) => {
                        return data.isSelected == true;
                    })
                    if (keyval.length > 0) {
                        selCategory.keyValues = keyval;
                    }
                    this.cohortFilterRadios.map((radio) => {
                        let keyval = cat.keyValues.filter((data) => {
                            return radio == data.itemValue && data.isSelected == false;
                        })
                        if (keyval.length > 0) {
                            selCategory.keyValues = keyval;
                        }
                    })
                    if (selCategory.keyValues.length > 0) {
                        selectedCategories.push(selCategory);
                    }
                })

                this.$store.dispatch('CategoriesStore/settblCohortFilters', selectedCategories);

                var countMeasure = 0
                for (var k = 0; k < selectedCategories.length; k++) {
                    var measure = selectedCategories[k];
                    if (measure.categoryName == "Measures") {
                        countMeasure = selectedCategories[k].keyValues.length;
                    }
                }
                if (countMeasure == 0) {
                    this.$store.dispatch('AppStore/SetAlert', { alert: 'Please select Measure!', isError: true })
                }
                else {

                    var selectedUserSettings = [];
                    for (var l = 0; l < this.userSettingData.length; l++) {
                        if (this.userSettingData[l].showOnDefault) {
                            var name = this.userSettingData[l].settingName;
                            var userSettingId = this.userSettingData[l].userSettingId;
                            var userSetting = {
                                userSettingId: userSettingId,
                                settingName: name,
                                itemValues: []
                            }
                            userSetting.itemValues = this.userSettingData[l].itemValues;
                            selectedUserSettings.push(userSetting);
                        }
                    }
                    this.$store.dispatch('UserSettingStore/settblCohortListFilters', selectedUserSettings);

                    //this.$store.state.UserSettingStore.tblCohortListFilters = this.userSettingData;

                    this.$store.state.CategoriesStore.cohortFiltersApplied = false;
                    this.Loading = true;
                    this.$store.dispatch('SegmentMeasureStore/resetCompositeQuestionText')
                    this.$store.dispatch('SegmentMeasureStore/getCompositeQuestionTextForCohort')
                        .then(() => {
                        }).catch(error => {
                            this.Loading = false;
                            this.$store.dispatch('AppStore/SetAlert', { alert: error, isError: true })
                        })
                    this.$store.dispatch('SegmentMeasureStore/GetClientDataWithCohort')
                        .then(() => {
                            this.Loading = false;
                        }).catch(error => {
                            this.Loading = false;
                            this.$store.dispatch('AppStore/SetAlert', { alert: error, isError: true })
                        })
                }
            },
            expandAll() {
                this.panel = [];
                for (var i = 0; i < this.filterCategories.length; i++) {
                    this.panel.push(i);
                }
            },
            collapseAll() {
                this.panel = [];
            },
            checkIfPanelCollapsed() {
                var result = true;
                for (var i = 0; i < this.panel.length; i++) {
                    if (this.panel[i] == i) {
                        result = false;
                    }
                }
                return result;
            },
            checkIfPanelExpanded() {
                var result = false;
                for (var i = 0; i < this.panel.length; i++) {
                    if (this.panel[i] == i) {
                        return true;
                    }
                }
                return result;
            },
            addNewCohort() {
                this.dialog = true;
            },
            cancelDialog() {
                this.dialog = false;
            },
            getCohortName() {
                if (this.userSettingData.length == 0) return 1;
                var lastCohort = this.userSettingData[this.userSettingData.length-1];
                var index = lastCohort.settingName.indexOf('-');
                var lastCohortId = lastCohort.settingName.substring(index+1, lastCohort.length);
                return +lastCohortId + 1;
                //userSettingData.length == 0 ? 1 : userSettingData.length + 1
            }
        }
    };
</script>
<style lang="scss">
    .disable-events {
        pointer-events: none
    }

    .scroll-area {
        position: absolute;
        margin: auto;
    }

    .drawer-menu--scroll {
        height: auto;
        overflow: auto;
    }

    /*.filter-list {
        max-height: 100vh;
    }*/
</style>

